import React from 'react';
import DefaultLayout from '../../../layouts/default';
import { MonthlyRotaProvider } from './context/MonthlyRotaContext';
import MonthlyHeader from './components/MonthlyHeader';
import Step1MonthlyDetails from './components/Step1MonthlyDetails';
import Step2StaffSelection from './components/Step2StaffSelection';
import Step3MonthlySchedule from './components/Step3MonthlySchedule';
import Step4Checks from './components/Step4Checks';
import Step5Notifications from './components/Step5Notifications';
import Step6Settings from './components/Step6Settings';
import MonthlyFooter from './components/MonthlyFooter';

const AddMonthlyRotaPage = () => {
  return (
    <MonthlyRotaProvider>
      <DefaultLayout>
        <div className="max-w-[1600px] mx-auto p-4 bg-slate-50 min-h-screen space-y-6">
          <MonthlyHeader />
          <main className="space-y-6">
            <Step1MonthlyDetails />
            <Step2StaffSelection />
            <Step3MonthlySchedule />
            <Step4Checks />
            <Step5Notifications />
            <Step6Settings />
          </main>
          <MonthlyFooter />
        </div>
      </DefaultLayout>
    </MonthlyRotaProvider>
  );
};

export default AddMonthlyRotaPage;
